/* AMBRE core behaviour (pass 2): header, drawers, rotators, cards, collection filters, cart drawer. No dependencies.
   Product page behaviour lives in am-pdp.js. Public API: window.AM.cart.add(items), window.AM.cart.open(), window.AM.money(cents). */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var AM = window.AM = window.AM || {};
  var root = AM.root || '/';

  if (typeof AM.money !== 'function') {
    var fmt0 = typeof AM.money === 'string' ? AM.money : (AM.moneyFormat || '${{amount}}');
    AM.money = function (cents) {
      var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt0.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n).replace(/<[^>]+>/g, '');
    };
  }

  /* ---------- drawers ---------- */
  function openDw(id) {
    var d = document.getElementById(id); if (!d) return;
    $$('.am-dw.is-open').forEach(function (o) { if (o !== d) closeDw(o); });
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('am-lock');
    var inp = $('input[type=search]', d); if (inp) setTimeout(function () { inp.focus(); }, 80);
  }
  function closeDw(d) {
    if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    d.classList.remove('has-sub'); $$('.am-side__sub.is-on', d).forEach(function (s) { s.classList.remove('is-on'); });
    $$('.am-side__row.is-on', d).forEach(function (s) { s.classList.remove('is-on'); });
    if (!$('.am-dw.is-open')) document.body.classList.remove('am-lock');
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-am-open]');
    if (t) { e.preventDefault(); openDw(t.getAttribute('data-am-open')); return; }
    t = e.target.closest('[data-am-close]');
    if (t) { e.preventDefault(); closeDw(t.closest('.am-dw')); return; }
    t = e.target.closest('[data-am-sub]');
    if (t) {
      var side = t.closest('.am-side'); var sub = document.getElementById(t.getAttribute('data-am-sub')); var was = sub.classList.contains('is-on');
      $$('.am-side__sub', side).forEach(function (s) { s.classList.remove('is-on'); });
      $$('.am-side__row', side).forEach(function (s) { s.classList.remove('is-on'); });
      if (!was) { sub.classList.add('is-on'); t.classList.add('is-on'); side.classList.add('has-sub'); } else side.classList.remove('has-sub');
      return;
    }
    t = e.target.closest('[data-am-sub-close]');
    if (t) { var sd = t.closest('.am-side'); t.closest('.am-side__sub').classList.remove('is-on'); sd.classList.remove('has-sub'); $$('.am-side__row', sd).forEach(function (s) { s.classList.remove('is-on'); }); return; }
    t = e.target.closest('[data-am-copy]');
    if (t) { var code = t.getAttribute('data-am-copy'); if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {}); t.classList.add('is-copied'); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.am-dw.is-open').forEach(closeDw); });

  /* ---------- header hides on scroll down, returns on scroll up ---------- */
  (function () {
    var sec = $('.am-hd-sec'); if (!sec) return; var last = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > last && y > 200) sec.classList.add('is-hidden'); else if (y < last) sec.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  })();

  /* ---------- rotators: announcement bar and hero slideshow ---------- */
  $$('[data-am-rotate]').forEach(function (el) {
    var slides = $$('.am-ann__s, .am-hero__s', el); var dots = $$('[data-am-dot]', el); if (slides.length < 2) return;
    var i = 0, ms = parseInt(el.getAttribute('data-am-rotate'), 10) || 6000, timer;
    function go(n) { i = (n + slides.length) % slides.length; slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); }); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
    function start() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, ms); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    if (!(window.Shopify && Shopify.designMode)) start();
  });

  /* ---------- scroll snap dots (text with icons on mobile) ---------- */
  $$('[data-am-snap]').forEach(function (el) {
    var track = $('[data-am-snap-track]', el), dots = $$('[data-am-snap-dot]', el); if (!track || !dots.length) return;
    track.addEventListener('scroll', function () { var k = Math.round(track.scrollLeft / track.clientWidth); dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); }); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); }); });
  });

  /* ---------- product cards: a swatch relabels the card to that colour ---------- */
  function setCardColor(card, name) {
    var sws = $$('[data-am-card-sw]', card); var hit = false;
    sws.forEach(function (s) { var on = s.getAttribute('data-am-card-sw') === name; if (on) hit = true; });
    var has = (card.getAttribute('data-colors') || '').split(',').indexOf(name) > -1;
    if (!has) return;
    if (hit) sws.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-am-card-sw') === name); });
    var lab = $('[data-am-card-color]', card); if (lab) lab.textContent = name;
    var img = $('[data-am-card-img]', card);
    if (img) { var tpl = $$('template[data-alt]', card).filter(function (t) { return t.getAttribute('data-alt').toLowerCase().indexOf(name.toLowerCase()) > -1; })[0]; if (tpl) { img.removeAttribute('srcset'); img.src = tpl.innerHTML.trim(); } }
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-am-card-sw]'); if (!s) return; e.preventDefault();
    setCardColor(s.closest('[data-am-card]'), s.getAttribute('data-am-card-sw'));
  });

  /* ---------- collection page: category tabs, colour filter, sticky colour bar ---------- */
  (function () {
    var box = $('[data-am-collection]'); if (!box) return;
    var tabs = $$('[data-am-tab]'), groups = $$('[data-am-group]', box);
    function show(h, push) {
      var g = groups.filter(function (x) { return x.getAttribute('data-am-group') === h; })[0]; if (!g) { g = groups[0]; h = g && g.getAttribute('data-am-group'); }
      groups.forEach(function (x) { x.hidden = x !== g; });
      tabs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-am-tab') === h); });
      var own = $$('[data-am-sws]', box).filter(function (s) { return s.getAttribute('data-am-sws') === h; });
      $$('[data-am-sws]', box).forEach(function (s) { s.hidden = s.getAttribute('data-am-sws') !== (own.length ? h : ''); });
      if (own.length && g) {
        var first = $('[data-am-color]', own[0]), nm = first && first.getAttribute('data-am-color');
        if (nm) {
          own.forEach(function (s) { $$('[data-am-color]', s).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-am-color') === nm); }); });
          $$('[data-am-card]', g).forEach(function (card) { setCardColor(card, nm); });
        }
      }
      if (push && h) { var u = new URL(location.href); u.searchParams.set('collection', h); history.replaceState(null, '', u); }
    }
    var want = new URLSearchParams(location.search).get('collection') || box.getAttribute('data-default') || (tabs[0] && tabs[0].getAttribute('data-am-tab'));
    show(want, true);
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-am-tab'), true); }); });
    document.addEventListener('click', function (e) {
      var c = e.target.closest('[data-am-color]'); if (!c) return; var name = c.getAttribute('data-am-color');
      $$('[data-am-color]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-am-color') === name); });
      $$('[data-am-card]', box).forEach(function (card) { setCardColor(card, name); });
    });
    var side = $('[data-am-color-side]', box), sticky = $('[data-am-color-sticky]', box);
    if (side && sticky) window.addEventListener('scroll', function () { var r = side.getBoundingClientRect(), b = box.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0 && b.bottom > 200); }, { passive: true });
  })();

  /* ---------- cart drawer ---------- */
  var Cart = AM.cart = {
    el: function () { return document.getElementById('am-cart'); },
    open: function () { openDw('am-cart'); Cart.tick(); },
    close: function () { closeDw(Cart.el()); },
    post: function (path, body) { return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); },
    refresh: function (open) {
      return fetch(root + '?section_id=am-cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = doc.querySelector('#am-cart-inner'), cur = $('#am-cart-inner');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.dataset.count = fresh.dataset.count; $$('[data-am-cart-count]').forEach(function (e) { e.textContent = fresh.dataset.count; e.setAttribute('data-n', fresh.dataset.count); }); }
        Cart.tick(); if (open) Cart.open();
        document.dispatchEvent(new CustomEvent('am:cart:updated'));
      });
    },
    busy: function (p) { var c = Cart.el(); if (c) c.classList.add('is-busy'); var done = function () { if (c) c.classList.remove('is-busy'); }; return p.then(function (x) { done(); return x; }, function (e) { done(); throw e; }); },
    change: function (key, qty) { return Cart.busy(Cart.post('cart/change.js', { id: key, quantity: qty }).then(function () { return Cart.refresh(); })); },
    add: function (items) { return Cart.post('cart/add.js', { items: items }).then(function (j) { try { if (!sessionStorage.getItem('amCartT')) sessionStorage.setItem('amCartT', String(Date.now())); } catch (e) {} return Cart.refresh(true).then(function () { return j; }); }); },
    tick: function () {
      var el = $('[data-am-countdown]'); if (!el) return; var total = parseInt(el.getAttribute('data-am-countdown'), 10) || 600, t0;
      try { t0 = parseInt(sessionStorage.getItem('amCartT'), 10); if (!t0) { t0 = Date.now(); sessionStorage.setItem('amCartT', String(t0)); } } catch (e) { t0 = Date.now(); }
      var left = total - Math.floor((Date.now() - t0) / 1000); if (left <= 0) { left = total; try { sessionStorage.setItem('amCartT', String(Date.now())); } catch (e) {} }
      var m = Math.floor(left / 60), s = left % 60; el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
  };
  setInterval(Cart.tick, 1000);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-am-cart-open]');
    if (t && Cart.el()) { e.preventDefault(); Cart.refresh(true); return; }
    t = e.target.closest('[data-am-qty]');
    if (t) { Cart.change(t.getAttribute('data-am-qty'), parseInt(t.getAttribute('data-q'), 10)); return; }
    t = e.target.closest('[data-am-rm]');
    if (t) { Cart.change(t.getAttribute('data-am-rm'), 0); return; }
    t = e.target.closest('[data-am-sp-toggle]');
    if (t) {
      var sp = t.closest('[data-am-sp]'), vid = sp.getAttribute('data-variant'), key = sp.getAttribute('data-key');
      if (!vid) { sp.classList.toggle('is-on'); return; }             /* product still a draft: visual only */
      if (key) Cart.change(key, 0); else Cart.busy(Cart.post('cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] }).then(function () { return Cart.refresh(); }));
    }
  });

  /* ---------- draft preview: point product and collection links at something that renders ---------- */
  (function () {
    var el = document.getElementById('am-draft-map'); if (!el) return; var map;
    try { map = JSON.parse(el.textContent); } catch (e) { return; }
    function fix(a) {
      var href = a.getAttribute('href'); if (!href || href.charAt(0) === '#') return; var u;
      try { u = new URL(href, location.origin); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      var m = u.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) { var h = map.alias[m[1]] || m[1]; if (map.products[h]) a.setAttribute('href', '/products_preview?preview_key=' + map.products[h]); return; }
      m = u.pathname.match(/\/collections\/([^\/?#]+)/);
      if (m && m[1] !== 'all') { if (map.views && map.views[m[1]]) { a.setAttribute('href', '/collections/all?view=' + map.views[m[1]]); return; } var c = u.searchParams.get('collection') || map.tabs[m[1]] || m[1]; a.setAttribute('href', '/collections/all?collection=' + encodeURIComponent(c)); }
    }
    function run(r) { $$('a[href]', r).forEach(fix); }
    run(document); document.addEventListener('am:cart:updated', function () { run(document.getElementById('am-cart')); });
  })();
})();
